export default __webpack_public_path__ + "static/media/rugfreecoins.81dee8eb.png";